// Import dependencies
import React from 'react';
import axios from 'axios';
import { tokenize } from '../../../../../helper';

// Import config
import config from '../../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class AccountSettingsSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            credentials: {
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: '',
                name: '',
                email: '',
            },
            
            // State variables for changing account name or email
            invalidEmail: false,
            settingsUpdateSuccess: false,
            settingsUpdateMessage: '',

            // State variables for changing password
            invalidOldPassword: false,
            invalidNewPassword: false,
            updatePasswordSuccess: false,
            updatePasswordMessage: ''
        }
    }

    componentDidMount = () => {
        axios.get(`${SETTINGS_URL}/account`, tokenize())
        .then(response => {
            var payload = response.data;
            if(payload.success) {
                var credentials = this.state.credentials;
                credentials.name = payload.accountSettings.name;
                credentials.email = payload.accountSettings.email;
                this.setState({ credentials });
            }
        })
        .catch(error=>{

        })
    }

    handleCredentialsFieldUpdate = (fieldName) => (event) => {
        var credentials = this.state.credentials;
        credentials[fieldName] = event.target.value;
        this.setState({ credentials });
    }
    
    emailIsValid = () => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.credentials.email);
    }

    submitAccountSettings = () => {
        if(this.emailIsValid()) {
            var newSettings = { name: this.state.credentials.name, email: this.state.credentials.email };
            axios.patch(`${SETTINGS_URL}/account`, tokenize({ newSettings }))
            .then(response => {
                var payload = response.data;
                if(payload.success) {
                    this.setState({ invalidEmail: false, settingsUpdateSuccess: true, settingsUpdateMessage: "Successuflly updated name and email." });
                } else {
                    this.setState({ invalidEmail: false, settingsUpdateSuccess: false, settingsUpdateMessage: "Email is already in use by another admin." });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ invalidEmail: false, settingsUpdateSuccess: false, settingsUpdateMessage: "Failed to update settings. Refresh and try again. If issue persists contact support." })
            })
        } else {
            this.setState({ invalidEmail: true, settingsUpdateSuccess: false, settingsUpdateMessage: "Please enter a valid email address." });
        }
    }

    submitPassword = () => {
        // console.log(this.state.credentials);
        var { oldPassword, newPassword, confirmNewPassword } =  this.state.credentials;
        
        if(oldPassword === '') {
            this.setState({ invalidOldPassword: true, updatePasswordSuccess: false, updatePasswordMessage: 'Please complete all fields highlighted in red.' });
        } else {
            this.setState({ invalidOldPassword: false });
        }

        if(newPassword === '' || confirmNewPassword === '') {
            this.setState({ invalidNewPassword: true, updatePasswordSuccess: false, updatePasswordMessage: 'Please complete the fields highlighted in red.' });
        } else if(newPassword === confirmNewPassword && oldPassword !== '' && newPassword !== '') {
            var credentials = { oldPassword: this.state.credentials.oldPassword, newPassword: this.state.credentials.newPassword };
            axios.patch(`${SETTINGS_URL}/account/password`, tokenize({ credentials }))
            .then(response => {
                var payload = response.data;
                console.log(payload);
                var credentials = this.state.credentials;

                if(payload.success) {
                    credentials.oldPassword = '';
                    credentials.newPassword = '';
                    credentials.confirmNewPassword = '';
                    this.setState({ credentials, invalidNewPassword: false, invalidOldPassword: false, updatePasswordSuccess: true, updatePasswordMessage: 'Successfully updated your admin password.' })
                } else {
                    credentials.oldPassword = '';
                    this.setState({ invalidOldPassword: true, invalidNewPassword: false, updatePasswordSuccess: false, updatePasswordMessage: 'The old password is incorrect.', credentials });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ updatePasswordSuccess: false, updatePasswordMessage: 'Unable to update password. Refresh page and try again. If issue persists notify DCE support.' });
            })
        } else if(oldPassword === '') {
            this.setState({ invalidOldPassword: true, updatePasswordSuccess: false, updatePasswordMessage: 'Please complete all fields highlighted in red.' });
        } else {
            this.setState({ invalidNewPassword: true, updatePasswordSuccess: false, updatePasswordMessage: "Passwords don't match." });
        }
    }

    render() {
        return (
            <div>
                <div className='card'>
                    <div className='card-header'>
                        <h3 className='card-title'>Change your Admin Account Settings</h3>
                        <p className='card-subtitle'>This is the email YOU use to log into the admin portal. This is NOT a member email.</p>
                    </div>
                    <div className='card-body'>
                        <label htmlFor='nameField'>Name</label>
                        <input id='nameField' className='form-control' type='text' placeholder='How other admins see you as..' value={this.state.credentials.name} onChange={this.handleCredentialsFieldUpdate('name')} />

                        <label className='inputFormTopMargin' htmlFor='emailField'>Admin Email</label>
                        <input id='emailField' className={(this.state.invalidEmail) ? 'form-control is-invalid' : 'form-control'} type='text' placeholder='The email you use to login into the admin portal..' value={this.state.credentials.email} onChange={this.handleCredentialsFieldUpdate('email')} />

                        <button className='btn btn-primary inputFormTopMargin' onClick={this.submitAccountSettings}>Update Account Info</button>

                        {(this.state.settingsUpdateMessage !== '') ?
                            <div className={(this.state.settingsUpdateSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                                {this.state.settingsUpdateMessage}
                            </div>
                        :
                            ''
                        }
                    </div>
                </div>


                <div className='card'>
                    <div className='card-header'>
                        <h3 className='card-title'>Change your admin password</h3>
                        <p className='card-subtitle'>This is the password YOU use to log into the admin portal. This is NOT a member password.</p>
                    </div>

                    <div className='card-body'>
                        <label htmlFor='#oldPasswordInput'>Old Password</label>
                        <input id='oldPasswordInput' className={ (this.state.invalidOldPassword) ? 'form-control is-invalid' : 'form-control'} type='password' placeholder='Old password' value={this.state.credentials.oldPassword} onChange={this.handleCredentialsFieldUpdate('oldPassword')} />

                        <label className='inputFormTopMargin' htmlFor='#newPasswordInput'>New Password</label>
                        <input id='newPasswordInput' className={ (this.state.invalidNewPassword) ? 'form-control is-invalid' : 'form-control'} type='password' placeholder='New password' value={this.state.credentials.newPassword} onChange={this.handleCredentialsFieldUpdate('newPassword')} />

                        <label className='inputFormTopMargin' htmlFor='#confirmNewPasswordInput'>Confirm New Password</label>
                        <input id='confirmNewPasswordInput' className={ (this.state.invalidNewPassword) ? 'form-control is-invalid' : 'form-control'} type='password' placeholder='Confirm new password' value={this.state.credentials.confirmNewPassword} onChange={this.handleCredentialsFieldUpdate('confirmNewPassword')} />

                        {(this.state.updatePasswordMessage !== '') ?
                            <div className={(this.state.updatePasswordSuccess) ? 'alert alert-success inputFormTopMargin' : 'alert alert-danger inputFormTopMargin'}>
                                {this.state.updatePasswordMessage}
                            </div>
                        :
                            ''
                        }

                        <button className='btn btn-primary inputFormTopMargin' onClick={this.submitPassword}>Change Password</button>
                        
                    </div>
                </div>
            </div>
        )
    }
}


export default AccountSettingsSection;